import Navbar from "../components/Navbar";

export default function Badges() {
  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h2>Badges</h2>
      </div>
    </>
  );
}
